export const DEFAULT_INPUT_SIZE = 300;